import { render } from "./AddBalance.vue?vue&type=template&id=12558a39&scoped=true"
import script from "./AddBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBalance.vue?vue&type=script&setup=true&lang=js"

import "./AddBalance.vue?vue&type=style&index=0&id=12558a39&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12558a39"],['__file',"src/components/UI/modals/AddBalance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12558a39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12558a39', __exports__)) {
    api.reload('12558a39', __exports__)
  }
  
  module.hot.accept("./AddBalance.vue?vue&type=template&id=12558a39&scoped=true", () => {
    api.rerender('12558a39', render)
  })

}


export default __exports__